import { createFileRoute } from "@tanstack/react-router";
import { ShelfDetailPage } from "@/components/shelves/shelf-detail";
import { type ShelfSearch, shelfSearchSchema } from "@/lib/shelves";

export const Route = createFileRoute("/_app/shelves/$id")({
  validateSearch: shelfSearchSchema,
  component: ShelfRoute,
});

function ShelfRoute() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ShelfDetailPage
      shelfId={id}
      search={search}
      onSearchChange={(patch: Partial<ShelfSearch>) =>
        void navigate({ search: (prev) => ({ ...prev, ...patch }) })
      }
    />
  );
}
